export const checkIsRead = (val) => {
  switch (String(val)) {
    case '0':
      return true;
      break;
    case '2':
      return true;
      break;
    case '5':
      return false; //admin + write + read
      break;
    case '6':
      return true;
      break;

    default:
      return false;
      break;
  }
};
